import React, { useEffect, useRef } from "react"
import { Box } from "@mui/material"
import { CwComponentConfig } from "../models/cwComponentAppBarMenu"
import JsBarcode from "jsbarcode"
import DynamicParamsService from "@front-apps/core/services/dynamicParams"
import DialogService from "@front-apps/core/services/dialog"
import { DialogType } from "@front-apps/core/models/dialog"
import { PageConfig } from "@front-apps/core/models/pageConfig"

const CwBarcode = (props: PageConfig<CwComponentConfig.Barcode>) => {
    const { config } = props
    const canvasRef = useRef<HTMLCanvasElement>(null)

    const resolveValue = () => {
        DynamicParamsService.resolve([config.value]).then(
            (result) => {
                if (result) {
                    if (canvasRef.current) {
                        JsBarcode(canvasRef.current, result[0] as string, {
                            format: "CODE39", // Barcode format
                            width: 2,
                            height: 100,
                            displayValue: true,
                        })
                    }
                }
            },
            (err) => {
                console.error(err)
            }
        )
    }
    useEffect(() => {
        // premier init
        resolveValue()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    useEffect(() => {
        let subId: string | null = null
        // on s'abonne aux changements de route
        if (config.useRefreshListener)
            subId = DialogService.getInstance().subscribe(
                "pageRefesh",
                DialogType.REFRESH,
                props.name,
                () => {
                    resolveValue()
                }
            )

        // unsubscribe
        return () => {
            if (subId) DialogService.getInstance().unsubscribe(subId)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Box sx={{ display: "flex", gap: 2 }}>
                <canvas ref={canvasRef} />
            </Box>
        </Box>
    )
}

export default CwBarcode
